import React, { useState, useEffect, useRef } from 'react';
import { generateSudoku } from './sudokuLogic';
import html2canvas from 'html2canvas';

// ?? ???? difficulty: passedDifficulty ??? ?????? ??????? ?? AutoGenerator ??
const SudokuBoard = ({ onAddToBook, seed = null, difficulty: passedDifficulty = 'medium' }) => {
  const [board, setBoard] = useState(null);
  const [solution, setSolution] = useState(null);
  
  // ???? ????? ??????? ??????? ???? ???? ??????? ????? medium
  const [difficulty, setDifficulty] = useState(passedDifficulty);
  const [showSolution, setShowSolution] = useState(false);
  
  const [currentSeed, setCurrentSeed] = useState(seed || Date.now().toString());
  const printRef = useRef(); 

  const createGame = (newSeed = null) => {
    const s = newSeed || currentSeed;
    if (newSeed) setCurrentSeed(newSeed);

    const game = generateSudoku(difficulty, s);
    setBoard(game.puzzle);
    setSolution(game.solution);
    setShowSolution(false);
  };

  // ??? ????? ????? ?????? ????? ???? ??? ?????? ??????? ?? ?????
  useEffect(() => { createGame(); }, [difficulty, seed]);

  const handleNewGame = () => {
      const newS = Date.now().toString(); 
      createGame(newS);
  }

  const handleAddToBook = () => {
    if (printRef.current) {
      html2canvas(printRef.current).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        onAddToBook('Sudoku', imgData, { seed: currentSeed, difficulty });
      });
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
      <h2 style={{ fontFamily: 'sans-serif', color: '#2c3e50' }}>Sudoku ?? {seed && <small style={{fontSize:'12px'}}>ID: {seed}</small>}</h2>

      <div style={{ background: 'white', padding: '15px', borderRadius: '10px', display: 'flex', gap: '10px', marginBottom: '20px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}>
        {!seed && (
          <>
            <select value={difficulty} onChange={(e) => setDifficulty(e.target.value)} style={{ padding: '8px', borderRadius: '5px' }}>
              <option value="easy">Easy</option>
              <option value="medium">Medium</option>
              <option value="hard">Hard</option>
              <option value="expert">Expert</option> 
            </select>
            <button onClick={handleNewGame} style={{background:'#6c5ce7', color:'white', border:'none', padding:'8px 15px', borderRadius:'5px', cursor:'pointer'}}>?? New</button>
          </>
        )}
        <button onClick={() => setShowSolution(!showSolution)} style={{background: showSolution?'#e17055':'#00b894', color:'white', border:'none', padding:'8px 15px', borderRadius:'5px', cursor:'pointer'}}>
          {showSolution ? 'Hide' : 'Solution'}
        </button>
        {!seed && <button onClick={handleAddToBook} style={{background:'#e67e22', color:'white', border:'none', padding:'8px 15px', borderRadius:'5px', cursor:'pointer'}}>?? Add</button>}
      </div>

      <div ref={printRef} style={{ padding: '30px', background: 'white' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(9, 40px)', border: '4px solid #333', background: '#333', gap: '1px' }}>
          {board && board.map((row, rowIndex) => (
            row.map((cell, colIndex) => {
              const val = showSolution && cell === 0 ? solution[rowIndex][colIndex] : cell;
              const isThickRight = (colIndex + 1) % 3 === 0 && colIndex !== 8;
              const isThickBottom = (rowIndex + 1) % 3 === 0 && rowIndex !== 8;
              
              return (
                <div key={`${rowIndex}-${colIndex}`} style={{
                  width: '40px', height: '40px', background: 'white',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  fontSize: '20px', fontWeight: cell !== 0 ? 'bold' : 'normal',
                  color: cell !== 0 ? '#2c3e50' : '#e17055',
                  borderRight: isThickRight ? '4px solid #333' : '1px solid #ccc',
                  borderBottom: isThickBottom ? '4px solid #333' : '1px solid #ccc',
                }}>
                  {val !== 0 ? val : ''}
                </div>
              );
            })
          ))}
        </div>
      </div>
    </div>
  );
};
export default SudokuBoard;